import {
    absoluteToRelativeHref,
    useLocalizedHref
} from "@/libraries/web-framework/index.ts";

import { MicroCtaFields } from "../types.ts";

export function useLocalizedCtaUrl(ctaFields: MicroCtaFields | undefined) {
    return useLocalizedHref(absoluteToRelativeHref(ctaFields?.ctaUrl ?? ""));
}
